import React, {useEffect, useState} from "react";
import axios from "axios";
import {useParams} from "react-router-dom";
import {baseUrl, userLocation,} from "../Univ.js";
function OpToken() {
    const [appData, setAppData] = useState([]);
    const [hospData, setHospData] = useState([]);
    const {appt_id} = useParams();
    useEffect(() => {
        axios.get(baseUrl + "view-appointment/" + appt_id)
            .then((response) => {
                setAppData(response.data);
            })
            .catch((error) => {
                console.log(error);
            });
        axios.get(baseUrl + "view-hospital/" + userLocation + "/")
            .then((response) => {
                setHospData(response.data);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);
    const handlePrint = () => {
        const printContents =
            document.getElementById("invoice-print").innerHTML;
        const printWindow = window.open('', '', 'width=400,height=600');
        printWindow.document.write(`
    <html>
      <head>
        <title>OP Token</title>

        <style>

          body{
            font-family: Arial, sans-serif;
            padding:10px;
            margin:0;
            color:#000;
          }

          .token-slip{
            width:300px;
            margin:auto;
            border:2px dashed #000;
            padding:15px;
          }

          .token-header{
            text-align:center;
            border-bottom:1px dashed #000;
            padding-bottom:10px;
            margin-bottom:10px;
          }

          .hospital-name{
            font-size:20px;
            font-weight:bold;
            text-transform:uppercase;
          }

          .hospital-address{
            font-size:12px;
            margin-top:3px;
          }

          .token-title{
            text-align:center;
            font-size:18px;
            font-weight:bold;
            margin:10px 0;
            letter-spacing:2px;
          }

          .token-number{
            text-align:center;
            font-size:55px;
            font-weight:bold;
            margin:15px 0;
          }

          .token-row{
            display:flex;
            justify-content:space-between;
            margin-bottom:8px;
            font-size:14px;
          }

          .token-label{
            font-weight:bold;
          }

          .vital-box{
            border:1px solid #000;
            padding:10px;
            margin-top:15px;
          }

          .vital-row{
            margin-bottom:15px;
            font-size:14px;
            font-weight:bold;
          }

          .token-footer{
            margin-top:20px;
            text-align:center;
            border-top:1px dashed #000;
            padding-top:10px;
            font-size:12px;
          }

          @media print {

            body{
              margin:0;
              padding:0;
            }

            .token-slip{
              border:2px dashed #000;
            }

          }

        </style>

      </head>

      <body>

        <div class="token-slip">
          ${printContents}
        </div>

      </body>
    </html>
  `);
        printWindow.document.close();
        printWindow.focus();
        setTimeout(() => {
            printWindow.print();
            printWindow.close();
        }, 500);
    };
    return (
        <section className="container mt-3">

            <style>
                {`

        .token-wrapper{
          display:flex;
          justify-content:center;
          margin-top:20px;
        }

        .token-slip{
          width:320px;
          background:#fff;
          border:2px dashed #000;
          padding:15px;
          font-family:Arial, sans-serif;
          color:#000;
        }

        .token-header{
          text-align:center;
          border-bottom:1px dashed #000;
          padding-bottom:10px;
          margin-bottom:10px;
        }

        .hospital-name{
          font-size:20px;
          font-weight:bold;
          text-transform:uppercase;
        }

        .hospital-address{
          font-size:12px;
          margin-top:3px;
        }

        .token-title{
          text-align:center;
          font-size:18px;
          font-weight:bold;
          margin:10px 0;
          letter-spacing:2px;
        }

        .token-number{
          text-align:center;
          font-size:52px;
          font-weight:bold;
          margin:15px 0;
        }

        .token-row{
          display:flex;
          justify-content:space-between;
          margin-bottom:8px;
          font-size:14px;
        }

        .token-label{
          font-weight:bold;
        }

        .token-footer{
          margin-top:20px;
          text-align:center;
          border-top:1px dashed #000;
          padding-top:10px;
          font-size:12px;
        }

        .vital-box{
          border:1px solid #000;
          padding:8px;
          margin-top:10px;
        }

        .vital-row{
          margin-bottom:12px;
          font-size:14px;
          font-weight:bold;
        }

        @media print {

          body{
            margin:0;
            padding:0;
          }

          .no-print{
            display:none !important;
          }

          .token-slip{
            width:100%;
            border:none;
          }

        }

        `}
            </style>

            <div className="text-center no-print">
                <h3
                    className="p-2"
                    style={{
                        backgroundColor: "#0d6efd",
                        color: "#fff",
                        borderRadius: "10px",
                    }}
                >
                    OP Token Print
                </h3>
            </div>

            <div className="token-wrapper">

                <div className="token-slip" id="invoice-print">

                    {hospData.map((hospital) => (
                        <div className="token-header" key={hospital.id}>

                            <div className="hospital-name">
                                {hospital.hospital}
                            </div>

                            <div className="hospital-address">
                                {hospital.address}
                            </div>

                        </div>
                    ))}

                    {appData.map((app) => (
                        <div key={app.id}>

                            <div className="token-title">
                                OP TOKEN
                            </div>

                            <div className="token-number">
                                {app.tokid}
                            </div>

                            <div className="token-row">
                                <span className="token-label">Date</span>
                                <span>{app.appt_date}</span>
                            </div>

                            <div className="token-row">
                                <span className="token-label">UHID</span>
                                <span>{app.pat?.pat_id}</span>
                            </div>

                            <div className="token-row">
                                <span className="token-label">Patient</span>
                                <span>{app.pat?.patient}</span>
                            </div>

                            <div className="token-row">
                                <span className="token-label">Age / Gender</span>
                                <span>
                  {app.pat?.age} / {app.pat?.gender}
                </span>
                            </div>

                            <div className="token-row">
                                <span className="token-label">Doctor</span>
                                <span>{app.cons?.consultant}</span>
                            </div>

                            <div className="token-row">
                                <span className="token-label">Department</span>
                                <span>{app.cons?.department}</span>
                            </div>

                            <div className="vital-box">

                                <div className="vital-row">
                                    Weight : __________________
                                </div>

                                <div className="vital-row">
                                    BP : ______________________
                                </div>

                                <div className="vital-row">
                                    Temp : ___________________
                                </div>

                            </div>

                            <div className="token-footer">
                                Please wait for your token number
                                <br/>
                                Thank You
                            </div>

                        </div>
                    ))}

                </div>

            </div>

            <div
                className="mt-3 no-print"
                style={{
                    display: "flex",
                    justifyContent: "center",
                }}
            >
                <button
                    onClick={handlePrint}
                    style={{
                        padding: "10px 30px",
                        borderRadius: "10px",
                        backgroundColor: "#0d6efd",
                        color: "#fff",
                        border: "none",
                        fontWeight: "bold",
                    }}
                >
                    Print Token
                </button>
            </div>

        </section>
    );
}
export default OpToken;